export default __webpack_public_path__ + "static/sr-1790771a92177fa54428d04c14713486.svg";